import { useQuery } from '@tanstack/react-query'
import { fetchUserTasks, fetchAllTasks } from '@/entities/task/api/tasksApi'
import { tasksKeys } from '@/entities/task/model/tasksKeys'
import { fetchAndTransformTasks } from '../ui/lib/fetchAndTransformTasks'

const POLLING_TIMER = 10000

export const useMyTasksQuery = (accountId: string | undefined) =>
  useQuery({
    queryKey: tasksKeys.my(accountId ?? ''),
    queryFn: () => fetchAndTransformTasks(() => fetchUserTasks(accountId!)),
    enabled: !!accountId,
    refetchInterval: POLLING_TIMER,
  })

export const useAllTasksQuery = (enabled: boolean) =>
  useQuery({
    queryKey: tasksKeys.allTasks(),
    queryFn: () => fetchAndTransformTasks(fetchAllTasks),
    enabled,
  })
